

































import { Component, Vue, Provide } from "vue-property-decorator";
import Board from "./Board.vue";
import MovesList from "./MovesList.vue";
import GameSelector from "./GameSelector.vue";
import { STATE, PLAYER_X, PLAYER_O } from "@/constants";
import { Strategy } from "@/best-strategy";
import "./styles.scss";

@Component({
  components: {
    Board,
    MovesList,
    GameSelector
  }
})
export default class Game extends Vue {
  @Provide()
  board: string[] = [];

  @Provide()
  histories: string[][] = [];

  @Provide()
  nextPlayer = PLAYER_X;

  @Provide()
  winner = "N/A";

  @Provide()
  endGame = true;

  @Provide()
  strategy: Strategy;

  @Provide()
  newGameClicked = false;

  @Provide()
  opponent = "";

  mounted() {
    this.board = Array(9).fill("");
    this.histories = [[...this.board]];
    this.strategy = new Strategy(PLAYER_O, PLAYER_X);
  }

  get disableControls() {
    return !this.endGame && this.newGameClicked;
  }

  changePlayer() {
    this.nextPlayer = this.nextPlayer === PLAYER_X ? PLAYER_O : PLAYER_X;
  }

  announceWinner(state: STATE) {
    if (state == STATE.WINNER) {
      this.winner = this.nextPlayer;
      this.endGame = true;
      this.newGameClicked = false;
    } else if (state === STATE.TIED) {
      this.winner = "tied";
      this.endGame = true;
      this.newGameClicked = false;
    }
  }

  startGame(opponent: string) {
    this.endGame = false;
    this.newGameClicked = true;
    this.nextPlayer = PLAYER_X;
    this.winner = "N/A";
    this.histories = [Array(9).fill("")];
    this.board = [...this.histories[this.histories.length - 1]];
    this.opponent = opponent;
  }

  generateMoves(histories: string[][]) {
    this.histories = [...histories];
    this.board = [...this.histories[this.histories.length - 1]];

    if (
      !this.endGame &&
      this.opponent !== "player" &&
      this.nextPlayer === PLAYER_O
    ) {
      const move = this.strategy.findBestMove(this.board);
      console.log("move", move);
      const { idx } = move;
      const prevBoard = [...this.board];
      prevBoard[idx] = this.nextPlayer;
      this.board = prevBoard;
    }
  }
}
